// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
  height: 100dvh;
  max-height: 100dvh;
  width: 100dvw;
  max-width: 100dvw;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.app .suspense-spin {
  margin: auto;
}
.app .suspense-spin .suspense-spin-icon {
  font-size: 48px;
}
.result-spin {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/App.less"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AACF;AARA;EAUI,YAAA;AACJ;AAXA;EAaM,eAAA;AACN;AAIA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFF","sourcesContent":[".app {\n  height: 100dvh;\n  max-height: 100dvh;\n  width: 100dvw;\n  max-width: 100dvw;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n\n  .suspense-spin {\n    margin: auto;\n\n    .suspense-spin-icon {\n      font-size: 48px;\n    }\n  }\n}\n\n.result-spin {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@drawer-width: 600px;@primary-color: #137CBD;@info-color: #137CBD;@success-color: #0F9960;@warning-color: #D9822B;@error-color: #DB3737;@link-color: #137CBD;@font-size-base: 14px;@heading-color: rgba(0, 0, 0, 0.85);@text-color: rgba(0, 0, 0, 0.65);@text-color-secondary: rgba(0, 0, 0, .45);@disabled-color: rgba(0, 0, 0, .25);@border-radius-base: 0px;@border-color-base: #d9d9d9;@box-shadow-base: 0 2px 8px rgba(0, 0, 0, 0.15);"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
